<template>
    <div class="property" v-if="showEmpty || !isEmpty">
        <div class="property-label">
            <slot name="label">{{ label }}</slot>
        </div>
        <div class="property-value">
            <template v-if="isEmpty">
                {{ emptyValue }}
            </template>
            <template v-else>
                <slot>{{ catalog ? __([catalog, value]) : value }}</slot>
                <slot name="extend-value"/>
            </template>
        </div>
    </div>
</template>

<style lang="scss">
    .property:not(:last-child) {
        margin-bottom: $spacer-2;
    }
    .property-label {
        font-size: $font-size-sm;
        font-weight: bold;
        color: $dark-70;
    }
</style>

<script>
    export default {
        props: {
            label: {type: String, default: ''},
            value: {default: null},
            catalog: {type: String, default: null},
            emptyValue: {type: String, default: "Keine Angabe"},
            showEmpty: {type: Boolean, default: false},
        },

        computed: {
            isEmpty() {
                return (this.value === null || this.value === '') && !this.$scopedSlots.default;
            },
        },
    };
</script>